import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            averageRate: '',
            userId: '',
            name: '',
            rates: [],
        }
    },
    methods: {
        getRates: getRates,
        getRate: getRate,
        formatDate: formatDate,
        getRateStyle: getRateStyle,
        getName: getName,
        compareActive(a, b) {
            let aActive = a.active;
            let bActive = b.active;
            if (aActive)
                return -1;
            if (bActive)
                return 1;
            return 0;
        },

        compareOrders(a, b) {
            let aActive = a.activeOrders;
            let bActive = b.activeOrders;
            if (aActive > bActive)
                return -1;
            if (aActive < bActive)
                return 1;
            return 0;
        },

    },

    beforeMount() {
        if (session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/login');
            return;
        }
        this.userId = this.$route.query.id;
        this.name = this.$route.query.name;
        this.averageRate = this.$route.query.rate;
        this.getRates();
    },
}


function getRates() {
    var _self = this;
    AdminApiService.getCourierRate(this.userId)
        .then((response) => {
            _self.rates = response.data;
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function getRate(user){
    var courierRate = user.rate != null ? user.rate : 1;
    var list = [];
    var i = 0;
    for(i = 0; i < 5; i++){
        list.push({rate: i, selected: i < courierRate})
    }
    return list;
}

function getRateStyle(rate){
    if(rate.selected){
        return "color: #fcc201;"
    }else{
        return "color: #707070;"
    }
}

function formatDate(date) {
    return this.$moment(new Date(date )).format('DD-MM-YYYY - HH:mm')
}

function getName(item){
    if(item.customer != null) return item.customer.firstName + ' ' + item.customer.lastName;
    return item.companyStaff.firstName + ' ' + item.companyStaff.lastName + ' ( ' + item.companyStaff.company.name + ' ) ';
}


// WEBPACK FOOTER //
// ./src/components/RateAndBugs/CourierRate.js